import './SeasonsList.scss'
import Slider from "react-slick";
import { useState } from "react";
import { translateWord } from "../../Util/util";

export default function SeasonList({ seasons, callBackActiveSeasonIndex }) {

    const [activeSeasonIndex, setActiveSeasonIndex] = useState(0)
    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 6,
        initialSlide: 0,
    }


    const select_season = (index) => {
        setActiveSeasonIndex(index)
        callBackActiveSeasonIndex(index)
    }


    return (
        <div className="list_seasons">
            <h1>{translateWord('Seasons')}</h1>
            <Slider {...settings}>
                {seasons.map((elem, index) => {
                    return (
                        <div className={activeSeasonIndex === index ? "card_season active" : "card_season"}
                            key={elem.id} onClick={() => select_season(index)}>
                            <div className="arrow_seasons"></div>
                            <h2>{elem.season_translation ? (elem.season_translation.name || elem.name) : elem.name}</h2>
                        </div>
                    )
                })}
            </Slider>
        </div>
    )
}